import React, { useState, useEffect } from "react";
import axios from "axios";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import WrapperList from "./WrapperList";
import routes from "../../../app/routes";
import { getWindowDimension } from "../../../utils/getWindowDimension";

export default function MemberList({ controllerName, currentUserType }) {
  let [members, setMembers] = useState([]);
  let [archiveMembers, setArchiveMembers] = useState([]);
  let [loader, setLoader] = useState(true);

  const activeListName = "memberListActive",
    archiveListName = "memberListArchive";

  let assign = {
    memberListActive: members,
    memberListArchive: archiveMembers,
  };

  useEffect(() => {
    const { width, height } = getWindowDimension();
    if (width <= 991) {
      document.querySelector("#right-sidebar").classList.add("not-visible");
    }

    axios.get(routes.api.session_rooms.for_list).then((resp) => {
      const allMembers = resp.data.data;
      setLoader(false);
      let archived_at_field =
        currentUserType == "coach"
          ? "coach_archived_at"
          : "student_archived_at";

      let activeMembers = allMembers.filter(function (item) {
        return item.attributes[archived_at_field] == null;
      });

      setMembers(activeMembers);
      setArchiveMembers(
        allMembers.filter(function (item) {
          return item.attributes[archived_at_field] != null;
        })
      );

      if (allMembers.length > 0) {
        let hash = window.location.hash.substr(1),
          queryString = window.location.search,
          urlParams = new URLSearchParams(queryString),
          sessionRoomId = 0;

        if (urlParams.get("open-chat") != null) {
          sessionRoomId = urlParams.get("open-chat");
        } else {
          sessionRoomId = activeMembers[0].id;
        }

        let firstItem = document.querySelectorAll(
          `[data-session-room-id='${sessionRoomId}']`
        );
        firstItem[0].click();
      }
    });
  }, []);

  const saveSessionRoomState = (id, position) => {
    axios
      .post(routes.api.session_rooms.archive(id), { position })
      .then((resp) => {});
  };

  const saveSessionRoomPosition = (id, position) => {
    axios
      .post(routes.api.session_rooms.sort(id), { position })
      .then((resp) => {});
  };

  const move = (sourceId, sessionRoomId, startIndex, endIndex) => {
    let destId =
        sourceId == "memberListActive"
          ? "memberListArchive"
          : "memberListActive",
      sourceArray = Array.from(assign[sourceId]),
      destArray = Array.from(assign[destId]);

    let [removed] = sourceArray.splice(startIndex, 1);
    destArray.splice(endIndex, 0, removed);

    if (sourceId == activeListName && destId == archiveListName) {
      setMembers(sourceArray);
      setArchiveMembers(destArray);
    } else {
      setMembers(destArray);
      setArchiveMembers(sourceArray);
    }

    saveSessionRoomState(sessionRoomId, endIndex);
  };

  const reorder = (sourceId, sessionRoomId, startIndex, endIndex) => {
    let destId =
        sourceId == "memberListActive"
          ? "memberListArchive"
          : "memberListActive",
      result = Array.from(assign[sourceId]);

    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    if (sourceId == activeListName) {
      setMembers(result);
    } else {
      setArchiveMembers(result);
    }
    saveSessionRoomPosition(sessionRoomId, endIndex);
  };

  const onDragEnd = (result) => {
    const { source, destination, draggableId } = result;

    if (!destination) {
      return;
    }

    if (source.droppableId === destination.droppableId) {
      //reorder
      reorder(source.droppableId, draggableId, source.index, destination.index);
    } else {
      move(source.droppableId, draggableId, source.index, destination.index);
    }
  };

  const mobileBlockChange = (index, sourceId, sessionRoomId) => {
    let destId =
        sourceId == "memberListActive"
          ? "memberListArchive"
          : "memberListActive",
      result = Array.from(assign[destId]);
    move(sourceId, sessionRoomId, index, result.length);
  };

  return (
    <div className="inner-data session_rooms">
      {loader && (
        <div className="wait-loader">
          <i className="fa fa-spinner fa-spin green"></i>
        </div>
      )}
      {!loader && (
        <DragDropContext style={{ overflow: "auto" }} onDragEnd={onDragEnd}>
          <WrapperList
            title={currentUserType == "coach" ? "Members" : "Coaches"}
            name={activeListName}
            collection={members}
            mobileBlockChange={mobileBlockChange}
            controllerName={controllerName}
            currentUserType={currentUserType}
          />
          <WrapperList
            title="Archive"
            name={archiveListName}
            collection={archiveMembers}
            mobileBlockChange={mobileBlockChange}
            controllerName={controllerName}
            currentUserType={currentUserType}
          />
        </DragDropContext>
      )}
    </div>
  );
}
